import { render } from "./sku_wise_sale.vue?vue&type=template&id=a83f27f8&scoped=true"
import script from "./sku_wise_sale.vue?vue&type=script&lang=js"
export * from "./sku_wise_sale.vue?vue&type=script&lang=js"

import "./sku_wise_sale.vue?vue&type=style&index=0&id=a83f27f8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a83f27f8"]])

export default __exports__